export default {"src":"/_next/static/media/logo_ivory.7340ce1c.svg","height":567,"width":3320,"blurWidth":0,"blurHeight":0};